import { PhoneCountryCode } from '@/models/PhoneCountryCode'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<PhoneCountryCode>(PhoneCountryCode, {
	namespaced: true
})
